// pi-admin uses anonymous WAMP auth; cryptosign and tweetnacl are never invoked.
// This stub satisfies autobahn's static `require("tweetnacl")` without bundling
// the real library (~30 KB gz). If cryptosign auth is ever enabled, drop the alias
// in vite.config.js.
export default {
  sign: {
    keyPair: { fromSeed: () => ({ publicKey: null, secretKey: null }) },
    detached: () => null,
    seedLength: 32,
  },
  randomBytes: () => new Uint8Array(0),
};
